module.exports = __webpack_public_path__ + "img/Logo.128a2e87.png";